export const videoIds: Record<string, string> = {
  pt: "HSvOcqS_aYI",
  es: "2HDTIQyNN2k",
  en: "LHoHezha2Qw",
};
